(() => {
  'use strict';

  function drawer() {
    return document.getElementById('MobileDrawer');
  }

  function trigger() {
    return document.querySelector('[data-drawer-open="#MobileDrawer"]');
  }

  function setOpen(open) {
    const d = drawer();
    const t = trigger();
    if (!d) return;

    d.classList.toggle('is-open', open);
    d.setAttribute('aria-hidden', open ? 'false' : 'true');

    if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest && event.target.closest('[data-drawer-open="#MobileDrawer"]');
    if (opener) {
      event.preventDefault();
      event.stopImmediatePropagation();
      setOpen(true);
      return;
    }

    const closer = event.target.closest && event.target.closest('#MobileDrawer [data-drawer-close]');
    if (closer) {
      event.preventDefault();
      event.stopImmediatePropagation();
      setOpen(false);
    }
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer()?.classList.contains('is-open')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      setOpen(false);
    }
  }, true);

  document.addEventListener('shopify:section:load', () => {
    setOpen(false);
  });
})();
